export const REMINDER_TYPE_META = {
  client_confirmation_pending:       { label: "Client confirmation pending", short: "Pending confirm" },
  client_confirmation_stale:         { label: "Stale pending confirmation", short: "Stale (>24h)" },
  booking_24h_recheck:               { label: "Booking 24h recheck", short: "24h recheck" },
  booking_3h_final_check:            { label: "Final 3h check", short: "Final 3h check" },
  pickup_reminder_customer:          { label: "Customer pickup reminder", short: "Pickup (customer)" },
  return_reminder_customer:          { label: "Customer return reminder", short: "Return (customer)" },
  change_request_pending_business:   { label: "Change request waiting on you", short: "Change request" },
  verification_request_no_response:  { label: "Verification request no response", short: "Vrequest (48h)" },
  incident_unresolved_near_booking:  { label: "Incident affects booking within 24h", short: "Incident near booking" },
  incident_followup_recheck:         { label: "Incident still open (follow-up)", short: "Incident follow-up" },
  vehicle_return_due:                { label: "Vehicle return due (business)", short: "Return prep" },
  vehicle_not_ready_before_booking:  { label: "Vehicle not ready before booking", short: "Vehicle not ready" },
};

export const REMINDER_PRIORITY_META = {
  critical: { label: "Critical", bg: "bg-red-100", text: "text-red-800", border: "border-red-200" },
  high:     { label: "High",     bg: "bg-orange-100", text: "text-orange-800", border: "border-orange-200" },
  medium:   { label: "Medium",   bg: "bg-amber-100", text: "text-amber-800", border: "border-amber-200" },
  low:      { label: "Low",      bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-200" },
};

export const REMINDER_STATUS_META = {
  pending: { label: "Pending", bg: "bg-amber-100", text: "text-amber-800", border: "border-amber-200" },
  sent:    { label: "Sent",    bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-200" },
  skipped: { label: "Skipped", bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-200" },
  failed:  { label: "Failed",  bg: "bg-rose-100", text: "text-rose-800", border: "border-rose-200" },
};

export function PriorityPill({ priority, "data-testid": testId }) {
  const m = REMINDER_PRIORITY_META[priority] || REMINDER_PRIORITY_META.low;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${m.bg} ${m.text} ${m.border}`}
    >
      {m.label}
    </span>
  );
}

export function ReminderStatusBadge({ status, "data-testid": testId }) {
  const m = REMINDER_STATUS_META[status] || REMINDER_STATUS_META.pending;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${m.bg} ${m.text} ${m.border}`}
    >
      {m.label}
    </span>
  );
}
